<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-14 11:34:54
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-16 20:20:09
-->
<template>
  <div class="x-page-transfer">
    <div class="left-transfer-panel">
      <div class="transfer-title">
        <el-checkbox v-model="checLeftkAll" :indeterminate="isLeftIndeterminate" @change="handleCheckLeftAll">
          全选
        </el-checkbox>
        <slot name="leftTitle"></slot>
      </div>
      <slot name="left"></slot>
      <div class="transfer-contant" :class="{ none: !leftOptions || !leftOptions.length }">
        <el-checkbox-group
          v-if="leftOptions.length > 0"
          v-model="leftCheckList"
          @change="handleLeftChange"
          class="options-item"
        >
          <el-checkbox
            v-for="item in leftOptions"
            :key="item[attrOption.value]"
            :label="item[attrOption.value]"
            class="checkbox-item"
          >
            <span class="checked-label" :title="item[attrOption.label]">{{ item[attrOption.label] }}</span>
          </el-checkbox>
        </el-checkbox-group>
        <div v-else class="nodata"> 暂无数据 </div>
      </div>

      <x-pagination
        class="tranfer-page"
        v-if="isPagination"
        :layout="'prev, pager, next'"
        :limit.sync="pData.pageSize"
        :page.sync="pData.pageNum"
        :total="pData.total"
        @pagination="onPageChange"
      >
      </x-pagination>
    </div>
    <!-- 按钮 -->
    <div class="transfer-btn">
      <el-button
        circle
        type="primary"
        :disabled="leftCheckList.length === 0"
        icon="el-icon-arrow-right"
        @click="add"
      ></el-button>
      <el-button
        circle
        type="primary"
        :disabled="rightCheckList.length === 0"
        icon="el-icon-arrow-left"
        @click="remove"
      ></el-button>
    </div>
    <!-- 右边 -->
    <div class="right-transfer-panel">
      <div class="transfer-title">
        <el-checkbox v-model="checkRightAll" :indeterminate="isRightIndeterminate" @change="handleCheckRightAll">
          全选
        </el-checkbox>
        <slot name="rightTitle"></slot>
      </div>
      <slot name="right"></slot>
      <div class="transfer-contant" :class="{ none: !modeOptions || !modeOptions.length }">
        <el-checkbox-group
          v-if="modeOptions.length > 0"
          v-model="rightCheckList"
          @change="handleRightChange"
          class="options-item"
        >
          <el-checkbox
            v-for="(item, index) in modeOptions"
            :key="index"
            :label="item[attrOption.value]"
            class="checkbox-item"
          >
            <span class="checked-label" :title="item[attrOption.label]">{{ item[attrOption.label] }}</span>
          </el-checkbox>
        </el-checkbox-group>
        <div v-else class="nodata"> 暂无数据 </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'XPageTransfer',
    props: {
      title: {
        type: Array,
        default: () => []
      },
      isPagination: {
        type: Boolean,
        default: true
      },
      attrOption: {
        type: Object,
        default: () => {
          return { label: 'label', value: 'value' }
        }
      },
      fromData: {
        type: Array,
        default: () => []
      },
      toData: {
        type: Array,
        default: () => []
      },
      paginationData: {
        type: Object,
        required: false,
        default: () => ({
          pageSize: 10,
          pageNum: 1
        })
      }
    },
    data() {
      return {
        checLeftkAll: false,
        isLeftIndeterminate: true,
        checkRightAll: false,
        isRightIndeterminate: true,
        leftOptions: [],
        modeOptions: [],
        rightCheckList: [],
        leftCheckList: [],
        pData: {
          pageSize: 10,
          pageNum: 1
        }
      }
    },
    computed: {
      getCheckDataList() {
        return JSON.stringify(this.toData)
      },
      getleftOptons() {
        return JSON.stringify(this.fromData)
      }
    },
    watch: {
      getCheckDataList: {
        handler() {
          this.modeOptions = JSON.parse(JSON.stringify(this.toData))
        },
        deep: true,
        immediate: true
      },
      getleftOptons: {
        handler() {
          this.leftOptions = JSON.parse(JSON.stringify(this.fromData))
        },
        deep: true,
        immediate: true
      },
      paginationData: {
        handler(val) {
          if (Object.keys(val).length > 0) {
            this.pData = val
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      add() {
        const addList = this.leftOptions.filter((item) => this.leftCheckList.includes(item[this.attrOption.value]))
        if (!this.isPagination) {
          this.leftOptions = this.leftOptions.filter((item) => {
            return !this.leftCheckList.includes(item[this.attrOption.value])
          })
        }
        const result = [...addList, ...this.modeOptions]
        const rightKeys = this.modeOptions.map((v) => v[this.attrOption.value])
        this.modeOptions = [
          ...this.modeOptions,
          ...result.filter((item) => {
            return !rightKeys.includes(item[this.attrOption.value])
          })
        ]
        this.leftCheckList = []
        this.checLeftkAll = false
        this.isLeftIndeterminate = true
      },
      remove() {
        const removeList = this.modeOptions.filter((item) => this.rightCheckList.includes(item[this.attrOption.value]))
        this.modeOptions = this.modeOptions.filter((item) => !this.rightCheckList.includes(item[this.attrOption.value]))
        if (!this.isPagination) {
          this.leftOptions = [...removeList, ...this.leftOptions]
        }
        this.rightCheckList = []
        this.checkRightAll = false
        this.isRightIndeterminate = true
      },
      handleCheckLeftAll(val) {
        this.leftCheckList = val ? this.leftOptions.map((item) => item[this.attrOption.value]) : []
        this.isLeftIndeterminate = false
        this.checLeftkAll = val
      },
      handleCheckRightAll(val) {
        this.rightCheckList = val ? this.modeOptions.map((item) => item[this.attrOption.value]) : []
        this.isRightIndeterminate = false
        this.checkRightAll = val
      },
      handleLeftChange(val) {
        const checkedCount = val.length
        this.checLeftkAll = checkedCount === this.leftOptions.length
        this.isLeftIndeterminate = checkedCount > 0 && checkedCount < this.leftOptions.length
      },
      handleRightChange(val) {
        const checkedCount = val.length
        this.checkRightAll = checkedCount === this.modeOptions.length
        this.isRightIndeterminate = checkedCount > 0 && checkedCount < this.modeOptions.length
      },
      /**
       * 分页改变事件触发
       * @param value
       */
      onPageChange(value) {
        this.$emit('on-change', value, 'isPageChange')
      }
    }
  }
</script>
<style lang="scss" scoped>
  .x-page-transfer {
    display: flex;
    height: 400px;

    .left-transfer-panel {
      position: relative;
      display: flex;
      flex: 3;
      flex-direction: column;
      border: 1px solid #ebeef5;
      border-radius: 4px;
    }

    .transfer-title {
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      height: 40px;
      padding: 0 15px;
      border-bottom: 1px solid #ebeef5;
      background: #f5f7fa;
    }

    .transfer-btn {
      display: flex;
      flex-direction: column;

      /* align-items: center; */
      justify-content: center;
      padding: 0 20px;
    }

    .right-transfer-panel {
      display: flex;
      flex: 3;
      flex-direction: column;
      border: 1px solid #ebeef5;
      border-radius: 4px;
    }

    .transfer-contant {
      display: flex;
      flex: 1;
      flex-direction: column;
      padding-bottom: 30px;
      padding-left: 15px;

      &.none {
        align-items: center;
        justify-content: center;
      }
    }

    .options-item {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding: 10px 0;

      .checkbox-item {
        line-height: 20px;
        padding: 6px 0;
      }
    }

    .el-button + .el-button,
    .el-checkbox.is-bordered + .el-checkbox.is-bordered {
      margin-top: 30px;
      margin-left: 0;
    }

    .tranfer-page {
      position: absolute;
      right: 5px;
      bottom: 0;
    }
  }
</style>
